module.exports = __webpack_public_path__ + "static/media/mg4.e9f84505.png";